(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["songxin-back-to-top"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('songxin-back-to-top')) {
    customElements.define('songxin-back-to-top', class extends HTMLElement {
      connectedCallback() {
        const button = this.querySelector('button');
        if (!button) return;

        this.controller = new AbortController();
        const signal = this.controller.signal;
        const updateVisibility = () => {
          button.hidden = window.scrollY < 400;
        };

        window.addEventListener('scroll', updateVisibility, { passive: true, signal });
        window.addEventListener('pageshow', updateVisibility, { signal });
        button.addEventListener('click', () => {
          document.querySelector('.skip-to-content-link')?.focus({ preventScroll: true });
          window.scrollTo({
            top: 0,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
          });
        }, { signal });

        updateVisibility();
      }

      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
